import { IMAGE, type Rect } from 'src/components/showcase/showcase-config'

/**
 * Renders the SAME screenshot, positioned so that only `rect` is visible inside
 * the (overflow-hidden, positioned) parent. All offsets are percentages, so the
 * crop stays pixel-aligned with the base image at any size.
 */
export const CropImage = ({ rect }: { rect: Rect }) => {
  return (
    <img
      src={IMAGE.src}
      alt=""
      aria-hidden="true"
      width={IMAGE.width}
      height={IMAGE.height}
      draggable={false}
      style={{
        width: `${100 / rect.w}%`,
        left: `${(-100 * rect.x) / rect.w}%`,
        top: `${(-100 * rect.y) / rect.h}%`,
      }}
    />
  )
}

/** Cyan pill that slides between two tab labels, positioned relative to `rect`. */
export const TabPill = ({
  rect,
  indicator,
  isFlipped,
}: {
  rect: Rect
  indicator: { from: Rect; to: Rect }
  isFlipped: boolean
}) => {
  const t = isFlipped ? indicator.to : indicator.from
  return (
    <span
      className="tabpill"
      aria-hidden="true"
      style={{
        left: `${((t.x - rect.x) / rect.w) * 100}%`,
        top: `${((t.y - rect.y) / rect.h) * 100}%`,
        width: `${(t.w / rect.w) * 100}%`,
        height: `${(t.h / rect.h) * 100}%`,
      }}
    />
  )
}
